const translations = {
  Upload: "Nahrát",
  "Select Header": "Vybrat hlavičku",
  "Map Columns": "Mapovat sloupce",
  "Expected Column": "Očekávaný sloupec",
  Required: "Povinné",
  "Drop your file here": "Přetáhněte soubor sem",
  or: "nebo",
  "Browse files": "Procházet soubory",
  "Download Template": "Stáhnout šablonu",
  "Only CSV, XLS, and XLSX files can be uploaded": "Lze nahrát pouze soubory CSV, XLS a XLSX",
  "Select Header Row": "Vybrat řádek hlavičky",
  "Select the row which contains the column headers": "Vyberte řádek obsahující hlavičky sloupců",
  "Only the first sheet (&quot;{{sheet}}&quot;) of the Excel file will be imported. To import multiple sheets, please upload each sheet individually.": "Importuje se pouze první list (&quot;{{sheet}}&quot;) Excel souboru. Pro import více listů nahrajte prosím každý list samostatně.",
  "Cancel": "Zrušit",
  "Continue": "Pokračovat",
  "Your File Column": "Sloupec vašeho souboru",
  "Your Sample Data": "Vaše vzorová data",
  "Destination Column": "Cílový sloupec",
  "Include": "Zahrnout",
  "Submit": "Odeslat",
  "Loading...": "Načítání...",
  "Please include all required columns": "Prosím zahrňte všechny povinné sloupce",
  "Back": "Zpět",
  "- Select one -": "- Vyberte jeden -",
  "- empty -": "- prázdné -",
  "Import Successful": "Import byl úspěšný",
  "Upload Successful": "Nahrání bylo úspěšné",
  "Done": "Hotovo",
  "Upload another file": "Nahrát další soubor",
};

export default translations;
